export const generateSkillsData = (jobs, projects, skillCategories) => {
  const skillsMap = new Map();

  const initializeSkill = (skillName) => {
    if (!skillsMap.has(skillName)) {
      skillsMap.set(skillName, {
        name: skillName,
        weightedScore: 0,
        occurrences: 0,
        relatedTo: {
          projects: [],
          jobs: [],
        },
        lastUsed: 0,
      });
    }
  };

  jobs.forEach((job) => {
    [...(job.technologies || []), ...(job.capabilities || [])].forEach((tech) => {
      initializeSkill(tech);
      const skill = skillsMap.get(tech);
      skill.weightedScore += job.weight;
      skill.occurrences += 1;
      skill.lastUsed = Math.max(skill.lastUsed, job.weight);
      if (!skill.relatedTo.jobs.includes(job.id)) {
        skill.relatedTo.jobs.push(job.id);
      }
    });
  });

  projects.forEach((project) => {
    project.technologies.forEach((tech) => {
      initializeSkill(tech);
      const skill = skillsMap.get(tech);
      skill.weightedScore += project.weight;
      skill.occurrences += 1;
      if (!skill.relatedTo.projects.includes(project.id)) {
        skill.relatedTo.projects.push(project.id);
      }
    });
  });

  const calculateSkillLevel = (skill) => {
    const baseScore = skill.weightedScore * 1.25;
    const frequencyImpact = Math.log2(skill.occurrences + 1) * 0.5;
    const jobCount = skill.relatedTo.jobs.length;
    const jobDiversityBonus = jobCount * 0.4;
    const projectCount = skill.relatedTo.projects.length;
    const projectDiversityBonus = projectCount * 0.3;
    const recencyBonus = skill.lastUsed * 0.7;

    const rawScore =
      baseScore +
      frequencyImpact +
      jobDiversityBonus +
      projectDiversityBonus +
      recencyBonus;

    const scaledScore = Math.log2(rawScore + 1) * 13;
    const finalScore = Math.min(95, Math.max(50, Math.round(54 + scaledScore)));

    return finalScore;
  };

  return Object.entries(skillCategories).map(([category, techs]) => ({
    category,
    items: techs
      .filter((tech) => skillsMap.has(tech))
      .map((tech) => {
        const skillData = skillsMap.get(tech);
        return {
          name: tech,
          level: calculateSkillLevel(skillData),
          relatedTo: skillData.relatedTo,
          usage: {
            projectCount: skillData.relatedTo.projects.length,
            jobCount: skillData.relatedTo.jobs.length,
            totalUses: skillData.occurrences,
            weightedScore: skillData.weightedScore,
          },
        };
      })
      .sort((a, b) => b.level - a.level),
  }));
};
